import axios from "axios";
import store from "../index";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
const state = {



};

const getters = {


};

const actions = {

    createSku : async (context,settings) => {


        let url = "sku/create";



        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {



                return res.data.image
                //resolve(res);
            })
            .catch(err => {

                //console.log("errore", err.response.data.error);
                return {error:err.response.data.error}
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },



    destroyData : (context) =>{



    },


};

const mutations = {



};



export default {
    namespaced : true,
	state,
	mutations,
	getters,
	actions
}
